import Swal from 'sweetalert2'
import * as auth from '../app/modules/Auth/_redux/authRedux'
import { login_using_refresh_token } from '../app/modules/Auth/_redux/authCrud'

export default function setupAxios(axios, store) {
	axios.interceptors.request.use(
		(config) => {
			const {
				auth: { authToken },
			} = store.getState()

			if (authToken) {
				config.headers.Authorization = `Bearer ${authToken}`
				config.headers.fullurl = window.location.href
			}

			return config
		},
		(err) => Promise.reject(err),
	)

	// Single-flight refresh: concurrent 401s share one refresh request rather
	// than each firing their own and rotating the token out from under the others.
	let refreshInFlight = null

	const refreshSession = () => {
		if (refreshInFlight) return refreshInFlight

		const {
			auth: { refreshToken },
		} = store.getState()

		if (!refreshToken) return Promise.resolve(null)

		refreshInFlight = login_using_refresh_token({ refresh_token: refreshToken })
			.then((response) => {
				const data = response && response.data
				if (!data || !data.status) return null

				store.dispatch(
					auth.actions.login(data.auth_token, data.refresh_token, data.user),
				)
				return data.auth_token
			})
			.catch(() => null)
			.finally(() => {
				refreshInFlight = null
			})

		return refreshInFlight
	}

	axios.interceptors.response.use(
		(response) => response,
		async (error) => {
			// A network failure has no response; nothing to inspect or retry.
			if (!error.response) return Promise.reject(error)

			const { status } = error.response
			const original = error.config || {}

			if (status === 400 || status === 500) {
				return {
					...error.response,
				}
			}

			if (status === 401) {
				// Never try to refresh the refresh call itself, and only retry once.
				const isRefreshCall = String(original.url || '').includes(
					'login_using_refresh_token',
				)

				if (!isRefreshCall && !original.__isRetry) {
					const newToken = await refreshSession()
					if (newToken) {
						original.__isRetry = true
						original.headers = {
							...original.headers,
							Authorization: `Bearer ${newToken}`,
						}
						return axios(original)
					}
				}

				Swal.fire({
					icon: 'error',
					title: 'Session expired',
					html: `Your session has expired. Login again`,
				}).then(() => {
					window.location.href = '/logout'
				})
			}

			return error
		},
	)
}
